import { lazy } from 'react'

import { SetupLayout } from '../components'
import { AppRouteObject } from '../types'

// Lazy-loaded setup pages — keeps the initial bundle small
const OrganizationsPage = lazy(() => import('@/pages/organizations'))
const OrganizationSetupPage = lazy(() => import('@/pages/organization-setup'))
const OrganizationSetupLayout = lazy(
  () => import('@/pages/organization-setup/layout'),
)
const OrganizationInvitePage = lazy(
  () => import('@/pages/organization-setup/invite'),
)
const UserSetupLayout = lazy(() => import('@/pages/user-setup/layout'))
const UserSetupPage = lazy(() => import('@/pages/user-setup'))
const SubscriptionSetupLayout = lazy(
  () => import('@/pages/subscription-setup/layout'),
)
const SubscriptionSetupPage = lazy(() => import('@/pages/subscription-setup'))

// Setup routes configuration
export const setupRoutes: AppRouteObject[] = [
  // Organization list (basic setup layout)
  {
    element: <SetupLayout />,
    children: [
      {
        path: '/organizations',
        element: <OrganizationsPage />,
        title: 'Organizations',
      },
    ],
  },
  // Organization setup flow (with animated background)
  {
    element: <OrganizationSetupLayout />,
    children: [
      {
        path: '/organization-setup',
        element: <OrganizationSetupPage />,
        title: 'Organization setup',
      },
      {
        path: '/organization-setup/invite',
        element: <OrganizationInvitePage />,
        title: 'Invite team',
      },
    ],
  },
  // User setup routes
  {
    element: <UserSetupLayout />,
    children: [
      {
        path: '/user-setup',
        element: <UserSetupPage />,
        title: 'User setup',
      },
    ],
  },
  // Subscription setup routes
  {
    element: <SubscriptionSetupLayout />,
    children: [
      {
        path: '/:orgSlug/subscription-setup',
        element: <SubscriptionSetupPage />,
        title: 'Subscription setup',
      },
    ],
  },
]
